import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import { Row } from '@prisjakt/ui/list/variants';
import { BodySmallText } from '@prisjakt/ui/text/variants';

export const Wrapper = styled.section`
  padding: 0 ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing050};
`;

export const ListItem = styled(Clickable)`
  display: inline;
`;

export const HeaderLink = styled(BodySmallText)`
  color: ${p => p.theme.text.linkExternal};
  &:hover {
    color: ${p => p.theme.text.linkExternalHover};
  }
`;

export const NavigationLinks = styled.ul`
  list-style: none;
  width: 100%;
  min-width: 100%;
  columns: 4 auto;
  ${media.mediumDown`
    columns: 3 auto;
  `}
  ${media.smallOnly`
    columns: 2 auto;
  `}
`;

/* stylelint-disable no-descending-specificity */
export const NavigationLink = styled.li`
  margin-bottom: ${layout.measurements.spacing025};
  a > span,
  button {
    line-height: 1.2rem;
    color: ${p => p.theme.text.linkInternal};
    cursor: pointer;
    font-weight: 400;
    &:hover {
      color: ${p => p.theme.text.linkInternalHover};
      text-decoration: underline;
    }
  }
`;
/* stylelint-enable no-descending-specificity */

export const HorizontalScroll = styled.div`
  overflow: auto;
`;

export const PanelHeaderRow = styled(Row)`
  && {
    border-bottom: 1px solid ${p => p.theme.lines.secondary};
  }
`;

export const ShowAllCategoriesRow = styled(Row)`
  && {
    align-items: center;
    justify-content: flex-end;
    flex: 0 1 auto;
  }
`;
